<template>
    <div class="toast" :class="{'show': isOpen}">
        <div class="toast-box">
            <p class="message">{{msg}}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'toast',
    props: {
      message: String,
      time: Number,
    },
    watch: {
      message(value) {
        if (value) {
          this.isOpen = true
          this.msg = value
          const timeout = setTimeout(() => {
            this.isOpen = false
            this.$emit('close')
            clearTimeout(timeout)
          }, this.time || 2500)
        }
      }
    },
    data() {
        return {
            isOpen: false,
            msg: 'This is test!'
        }
    },
}
</script>

<style lang="scss" scoped>
.toast {
    position: fixed;
    z-index: 9;
    top: 0; bottom: 0;
    left: 0; right: 0;
    background-color: #0000;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    opacity: 0;
    pointer-events: none;
    transition: opacity .3s ease;
    &.show {
        opacity: 1;
        pointer-events: none;
        .toast-box {
            transform: translate(0, 0);
        }
    }
    .toast-box {
        width: calc(100% - 20px);
        max-width: 600px;
        margin: 10px;
        padding: 20px;
        background-color: var(--primary);
        border-radius: 5px;
        transform: translate(0, -200%);
        transition: transform .3s ease;
        box-shadow: 0 3px 6px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.1);
        .message {
          color: #fff;
          margin: 0;
          font-weight: 700;
        }
    }
}
</style>